import {
  Button,
  DialogFooter,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import {
  ClusterDialogHeading,
  StepContainer,
} from '../../_components/new-onboarding';
import { SecurityFeatureSelection } from '../types';
import { SecurityComplianceComplete } from './SecurityComplianceSetup';
import { SecurityVulnerabilityDetectionComplete } from './SecurityVulnerabilityDetectionSetup';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Props = {
  featureSelection: SecurityFeatureSelection;
  onClose: () => void;
};

export const SecurityFeaturesSuccessSlide = ({
  featureSelection,
  onClose,
}: Props) => {
  const { cluster } = useCluster();

  return (
    <StepContainer data-testid="success-step">
      <ClusterDialogHeading cluster={cluster} onClose={onClose} />
      <Stack p={16}>
        <Typography
          variant="L10M"
          color={tokens.theme.fg.structural.secondary}
          mb={8}
        >
          Enabled Features:
        </Typography>
        <Stack>
          <SecurityVulnerabilityDetectionComplete
            checked={featureSelection.vulnerabilityDetection}
          />
          <SecurityComplianceComplete checked={featureSelection.compliance} />
        </Stack>
      </Stack>
      <DialogFooter
        end={
          <Button onClick={onClose} testId="done-button">
            Done
          </Button>
        }
      />
    </StepContainer>
  );
};
